import Layout from "layouts/DashboardLayout.jsx";
import {
  Login,
  Register,
  Error400,
  ForgotPassword,
  Error500,
  EmailVerification,
  ResetPassword,
  VerifyOTP,
  Shared,
  SharedTour,
  SharedPhotoGallery,
  SharedVideoHub,
  SharedGeoTiff,
  SharedBimViewer
} from "pages";

const indexRoutes = [
  { path: "/shared", component: Shared },
  { path: "/sharedtour", component: SharedTour },
  { path: "/sharedphotos", component: SharedPhotoGallery },
  { path: "/sharedvideo", component: SharedVideoHub },
  { path: "/sharedgeotiff", component: SharedGeoTiff },
  { path: "/sharedgeoview", component: SharedGeoTiff },
  { path: "/sharedbim", component: SharedBimViewer },
  { path: "/login", component: Login },
  { path: "/register", component: Register },
  { path: "/verify_email/:token", component: EmailVerification },
  { path: "/verify-otp", component: VerifyOTP },
  { path: "/error400", component: Error400 },
  { path: "/error500", component: Error500 },
  { path: "/forgotPassword", component: ForgotPassword },
  { path: "/reset-password/:token", component: ResetPassword },
  { path: "/", component: Layout }
];

export default indexRoutes;
